import React from 'react';

const OnboardingProgressTracker = ({ steps, activeStep, completedSteps = [] }) => {
    return (
        <>
            <style>{`
                .onboarding-progress {
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    padding: 1.5rem 2rem;
                    gap: 0;
                }
                .onboarding-progress-step {
                    display: flex;
                    align-items: center;
                    gap: 0.5rem;
                    font-size: 0.8rem;
                    font-weight: 500;
                    color: #94a3b8;
                    white-space: nowrap;
                }
                .onboarding-progress-step.active {
                    color: var(--primary);
                    font-weight: 600;
                }
                .onboarding-progress-step.completed {
                    color: var(--primary);
                }
                .onboarding-progress-dot {
                    width: 28px;
                    height: 28px;
                    border-radius: 50%;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    font-size: 0.75rem;
                    font-weight: 600;
                    background: #f1f5f9;
                    color: #94a3b8;
                    border: 2px solid #e2e8f0;
                    flex-shrink: 0;
                }
                .onboarding-progress-step.active .onboarding-progress-dot {
                    background: var(--primary);
                    color: white;
                    border-color: var(--primary);
                }
                .onboarding-progress-step.completed .onboarding-progress-dot {
                    background: var(--primary);
                    color: white;
                    border-color: var(--primary);
                }
                .onboarding-progress-line {
                    flex: 1;
                    height: 2px;
                    background: #e2e8f0;
                    margin: 0 0.75rem;
                    min-width: 30px;
                }
                .onboarding-progress-line.completed {
                    background: var(--primary);
                }
                @media (max-width: 768px) {
                    .onboarding-progress {
                        padding: 1rem;
                    }
                    .onboarding-progress-step span:not(.onboarding-progress-dot) {
                        display: none;
                    }
                }
            `}</style>
            <div className="onboarding-progress">
                {steps.map((step, index) => (
                    <React.Fragment key={step.key}>
                        <div className={`onboarding-progress-step ${
                            activeStep === step.key ? 'active' : ''
                        } ${completedSteps.includes(step.key) ? 'completed' : ''}`}>
                            <div className="onboarding-progress-dot">
                                {completedSteps.includes(step.key) ? '✓' : index + 1}
                            </div>
                            <span>{step.label}</span>
                        </div>
                        {index < steps.length - 1 && (
                            <div className={`onboarding-progress-line ${
                                completedSteps.includes(step.key) ? 'completed' : ''
                            }`} />
                        )}
                    </React.Fragment>
                ))}
            </div>
        </>
    );
};

export default OnboardingProgressTracker;
